export const BROADCAST_APP_STORE_URLS = {
  android: 'https://play.google.com/store/apps/details?id=com.fanbirdbroadcast',
  ios: 'https://apps.apple.com/kr/app/fanbird/id6788635456',
};

export const getBroadcastAppInstallUrl = () => {
  if (/Android/i.test(navigator.userAgent)) {
    return BROADCAST_APP_STORE_URLS.android;
  }
  if (/iPad|iPhone|iPod/i.test(navigator.userAgent)
    || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
    return BROADCAST_APP_STORE_URLS.ios;
  }
  return null;
};
